module.exports = __webpack_public_path__ + "img/p-1.2e43a251.png";